import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withModelInfo } from '../../common/ModelInfoContext';

class GMWCContainer extends React.Component {
  constructor(props) {
    super(props);

    this.enabled = window.gmwc && props.modelInfo.enablePaymentEstimator;

    if (!this.enabled) {
      this.state = {};
    } else {
      this.manager = window.gmwc.StateManager;
      this.state = this.manager.get();
    }
  }

  onManagerChange = _.debounce(() => {
    const nextState = this.manager.get();
    if (!_.isEqual(this.state, nextState)) {
      this.setState(nextState);
    }
  }, 50);

  setManagerState = () => {
    const { modelInfo, config, postalCode } = this.props;
    const { msrp, style } = config;

    this.manager.set({
      year: modelInfo.year,
      msrp:
        _.get(msrp, 'vehicleTotalEmployeePriceForPe') ||
        _.get(msrp, 'totalMsrp', 0),
      employeeMsrp: _.get(msrp, 'employeePrice', 0),
      netPrice: _.get(config, 'summary.prices.netPrice.amount.value', 0),
      postalcode: postalCode,
      trim: style.vehicleInfo.code,
      freight: msrp.destination,
      employeeMsrpPriceInConsumerEnvForResidualCalculation:
        msrp.msrpForResidualCalculation,
      actax: msrp.acTax,
      dealerfee: msrp.dealerFee,
      options: msrp.optionsTotal.value,
      packages: msrp.packagesOptionsTotal.value,
      accessories: msrp.accessoriesTotal,
      rpo: config.selections.rpos,
    });
  };

  componentDidMount() {
    if (this.enabled) {
      this.setManagerState();
      this.manager.onChange(this.onManagerChange);
      this.unsubscribe = () => {
        // clean up internals since there is no exposed unsubscribe
        const subscriptions = this.manager._params._subscribers.set;
        const index = subscriptions.indexOf(this.onManagerChange);
        if (index !== -1) {
          subscriptions.splice(index, 1);
        }
      };
    }
  }

  componentDidUpdate(prevProps) {
    if (this.enabled) {
      if (JSON.stringify(this.props) !== JSON.stringify(prevProps)) {
        this.setManagerState();
      }
    }
  }

  componentWillUnmount() {
    if (this.enabled) {
      this.unsubscribe();
    }
  }

  render() {
    return this.props.children(this.state);
  }
}

GMWCContainer.propTypes = {
  config: PropTypes.object.isRequired,
  postalCode: PropTypes.string,
};

export default withModelInfo(GMWCContainer);
